import React from "react"
import PropTypes from "prop-types"
import { getValidLuxonDate } from "../../../utils/date.utils"

const SprintApprovalTemplate = ({ date, approverFullName }) => {
  if (!date || !approverFullName) {
    return null
  }
  return (
    <table
      style={{
        minWidth: "210px",
        fontSize: "12px",
      }}
    >
      <tbody>
        <tr>
          <td className="font-bold">Fecha</td>
          <td className="text-right">
            {getValidLuxonDate(date, {})?.toFormat("dd/MM/yyyy")}
          </td>
        </tr>
        <tr>
          <td className="font-bold white-space-nowrap">Responsable</td>
          <td className="text-right">{approverFullName}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default SprintApprovalTemplate

SprintApprovalTemplate.propTypes = {
  date: PropTypes.string,
  approverFullName: PropTypes.string,
}
